import { Suspense, lazy } from 'react';
import { Link } from 'react-router';
import { useSnapshot } from 'valtio';

import * as userStore from '@cartwhl/common/stores/userStore';
import { getAppletsUrl } from '@cartwhl/common/utils';
import {
  NewAppsBanner,
  useNewAppsBanner,
} from '@cartwhl/ui/layout/NewAppsBanner';
import UserMenuWithCredits from '@cartwhl/ui/organisms/UserMenuWithCredits';
import FrostedGlass from '@cartwhl/ui/utilities/FrostedGlass';
import '@cartwhl/ui/utilities/FrostedGlass.css';

const AnimatedLogo = lazy(() => import('@cartwhl/ui/atoms/AnimatedLogo'));

/** App dashboard shell: homepage animated logo + account menu (no marketing nav). */
export default function AppShellHeader() {
  const { theme } = useSnapshot(userStore.state);
  const { showBanner, dismissBanner } = useNewAppsBanner();

  return (
    <header
      className={`sticky z-50 flex flex-col ${
        showBanner ? 'top-0' : 'top-0 lg:top-[-16px]'
      }`}
    >
      {showBanner ? (
        <NewAppsBanner
          onDismiss={dismissBanner}
          comicHref={`${getAppletsUrl()}/comic`}
        />
      ) : null}

      <div
        className={`flex h-20 items-center justify-center px-2 lg:px-5 ${
          showBanner ? 'lg:h-24' : 'lg:h-[128px]'
        }`}
      >
        <FrostedGlass className="container rounded-lg bg-white/60 lg:rounded-full dark:bg-gray-90/60">
          <div className="flex h-16 items-center justify-between">
            <Link
              to="/"
              aria-label="Cartwheel home"
              className="flex items-center"
            >
              <Suspense fallback={null}>
                <AnimatedLogo theme={theme ?? 'light'} />
              </Suspense>
            </Link>
            <UserMenuWithCredits />
          </div>
        </FrostedGlass>
      </div>
    </header>
  );
}
